import React, { useState, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { updateApp, fetchApp } from '../store/actions/appAction';

import UploadImage from "../components/uploadImage";
import Header from '../components/Header'
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Menubar from '../components/Menubar';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
    appBar: {
      position: 'relative',
    },
    layoutMainCreateApp: {
      background: "white",
      padding: "2rem 2rem",
      borderRadius: "10px",
      [theme.breakpoints.up("sm")]: {
        width: "80%",
        marginLeft: 'auto',
        marginRight: 'auto',
      },
    },
    stepper: {
      padding: theme.spacing(3, 0, 5),
    },
    buttons: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    button: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
      marginLeft: theme.spacing(1),
    },
    contentCreateApp : {
      paddingTop: "3%",
      paddingLeft: "15%",
      backgroundColor: "#e8e8e8",
      paddingRight: "5%",
      paddingBottom: "14%",

      [theme.breakpoints.down("sm")]: {
        paddingTop: "30%",
        paddingLeft: "0",
        paddingRight: "0"
      },
    },
}));



const UpdateApp = () => {
    useEffect(() => {
      window.scrollTo(0, 0)
    }, [])
    const classes = useStyles();
    const dispatch = useDispatch()
    const history = useHistory()
    const {id} = useParams()
    const [ input, setInput ] = useState({
        appName: '',
        description: '',
        redirectUrlApp: '',
        logoUrl: ''
      })

    useEffect(() => {
      dispatch(fetchApp(id))
    }, [id])

    const app = useSelector(state => state.appReducer.app)

    useEffect(() => {
      if (app) {
        const newInput = {
          appName: app.appName? app.appName : '',
          description: app.description? app.description : '',
          redirectUrlApp: app.redirectUrlApp? app.redirectUrlApp : '',
          logoUrl: app.logoUrl? app.logoUrl : ''
        }
        setInput(JSON.parse(JSON.stringify(newInput)))              
        }
    }, [app])


    const handleImageData = (imageFile) => {
      setInput({ ...input, image: imageFile })
    }

    const handleSubmit = (e) => {
      e.preventDefault()
      const { appName, description, redirectUrlApp, image } = input
      const formData = new FormData()
      if (image) {
        formData.append('image', image)      
      }
      formData.append('appId', id)
      formData.append('appName', appName)
      formData.append('description', description)
      formData.append('redirectUrlApp', redirectUrlApp)

      dispatch(updateApp(formData))
      history.push('/app')
      
    }

    const handleChange = (e) => {
        let { name, value } = e.target
        setInput({ ...input, [name]: value })
    }

    const handleHome = () => {
      history.push('/app')
    }
        
    return (
        <React.Fragment>
        <Header page='CreateApp'/>
        <CssBaseline />
        <Menubar/>
        <Grid item xs={12} md={12} className={classes.contentCreateApp}>
        <main className={classes.layoutMainCreateApp}>
            <React.Fragment>
            <form className={classes.form} onSubmit={handleSubmit}>
            <Grid container spacing={3} style={{justifyContent: "center"}}>
                <Grid item xs={10} md={4} style={{border: "3px dashed #dadada"}}>
                  <UploadImage imageData={handleImageData}/>
                </Grid>
                <Grid item xs={12}>
                <p className="font-size-16 reguler text-darkgrey mb-5">Nama Aplikasi*</p>
                <TextField
                  variant="outlined"
                  margin="none"
                  size="small"
                  placeholder="Aplikasi Terbaik"
                  required
                  fullWidth
                  name="appName"
                  value={input.appName}
                  onChange={handleChange}
                />
                </Grid>
                <Grid item xs={12}>  
                <p className="font-size-16 reguler text-darkgrey mb-5">Deskripsi*</p>
                <TextField
                  id="outlined-multiline-static"
                  variant="outlined"
                  margin="none"
                  size="small"
                  placeholder="Deskripsi Website / Apps Anda"
                  defaultValue=""
                  required
                  fullWidth
                  multiline
                  rows={4}
                  name="description"
                  value={input.description}
                  onChange={handleChange}
                />
                </Grid>
                <Grid item xs={12}>
                <p className="font-size-16 reguler text-darkgrey mb-5">Redirect URL App*</p>
                <TextField
                  variant="outlined"
                  margin="none"
                  size="small"
                  placeholder="Masukkan Redirect URL"
                  required
                  fullWidth
                  name="redirectUrlApp"
                  value={input.redirectUrlApp}
                  onChange={handleChange}
                />
                </Grid>
            </Grid>
            <Grid xs={12} md={12} className="mt-15 d-flex" style={{justifyContent: "flex-end"}}>
              <Button
                className="btn-white mx-4 text-transform-unset"
                spacing={5}
                onClick={handleHome}
                style={{padding: "5px 40px"}}
              >
                Batal
              </Button>
              <Button
                type="submit"
                className="btn-black text-transform-unset"
                spacing={5}
                onClick={handleSubmit}
                style={{padding: "5px 40px"}}
              >
                Simpan
              </Button>
            </Grid>
            </form>
            </React.Fragment> 
          </main>
        </Grid>
      </React.Fragment>     
    )
}

export default UpdateApp